<template>
    <v-dialog-old ref="dialog" class="modalShadow_without-overflow">
        <ValidationObserver ref="clinicSubscription">
            <fieldset class="clinicSubscription" style="overflow: unset">
                <legend>Подписка</legend>

                <table class="grid">
                    <tr>
                        <td colspan="3">
                            <label>Тариф</label>
                            <ValidationProvider rules="required" v-slot="{errors}">
                                <v-select
                                    v-model="model.tariff"
                                    :class="{'hasError': errors[0]}"
                                    v-tooltip.right="{content: errors[0], template: $errTemplate}"
                                    :disabled="!canEditDateFrom"
                                    :options="[
                                    {
                                       text: '\u00a0',
                                       value: null,
                                    },
                                    {
                                        text: 'Подписка Стандарт',
                                        value: 'ABONEMENT',
                                    },
                                    {
                                        text: 'Подписка Премиум',
                                        value: 'ABONEMENT_PLUS',
                                    },
                                    {
                                        text: 'Личный кабинет',
                                        value: 'ONLY_LK',
                                    },
                                ]"/>
                            </ValidationProvider>
                        </td>
                    </tr>
                    <tr>
                        <td width="33%">
                            <label>Действует с</label>
                            <date-piker v-model="model.dateFrom"
                                        :clearable="false"
                                        :disabled="!canEditDateFrom"
                                        :disable-highlighting="true"
                                        :default-value="today"
                                        :disabled-date="(date) => date < startOfToday"/>
                        </td>
                        <td width="33%">
                            <label>Длительность</label>
                            <div class="selectinput">
                                <v-select
                                    :options="[
                                    {
                                       text: '\u00a0',
                                       value: null,
                                    },
                                    {
                                        text: '90 дней',
                                        value: '90',
                                    },
                                    {
                                        text: '180 дней',
                                        value: '180',
                                    },
                                    {
                                        text: '270 дней',
                                        value: '270',
                                    },
                                    {
                                        text: '360 дней',
                                        value: '360',
                                    }
                                ]"
                                    v-model="durationPreset"
                                    @input="setDurationPreset"
                                    :disabled="!canEditDateTill"
                                    :searchable="false"
                                />

                                <vee-input type="number"
                                           v-model="model.duration"
                                           step="1"
                                           v-units.literal="`дн`"
                                           @input="calculateDateTill"
                                           :disabled="!canEditDateTill"
                                           :invalid="model.duration < 0"
                                           :rules="{required: isTariffAbonement}"/>
                            </div>
                        </td>
                        <td width="33%">
                            <label>Действует по</label>
                            <ValidationProvider :rules="{required: isTariffAbonement}" v-slot="{errors}">
                                <div style="height: 23px; margin-bottom: 5px;"
                                     :class="{'hasError': errors[0]}"
                                     v-tooltip.bottom-end="{content: errors[0], template: $errTemplate}">
                                    <date-piker
                                        v-model="model.dateTill"
                                        :disabled-date="(date) => date < new Date(minDateTill)"
                                        @input="handleClearDateTill"
                                        @change="calculateDuration"
                                        :disabled="!canEditDateTill"
                                        :disable-highlighting="true"
                                        :input-attr="isTariffAbonement ? {required: 'required'} : {}"
                                    />
                                </div>
                            </ValidationProvider>
                        </td>
                    </tr>
                    <tr v-if="model.tariff === 'ABONEMENT' || model.tariff === 'ABONEMENT_PLUS'" class="subscribe-options">
                        <td class="subscribe-options__cell">
                            <label>
                                <input type="checkbox" v-model="model.option_calltracking">
                                <span>Коллтрекинг</span>
                            </label>
                        </td>
                        <td class="subscribe-options__cell">
                            <label>
                                <input type="checkbox" v-model="model.option_map">
                                <span>Карты</span>
                            </label>
                        </td>
                        <td class="subscribe-options__cell">
                            <label>
                                <input type="checkbox" v-model="model.option_callback">
                                <span>Обратный звонок</span>
                            </label>
                        </td>
                    </tr>
                    <tr v-if="model.tariff === 'ABONEMENT_PLUS'" class="subscribe-options">
                           <td class="subscribe-options__cell">
                        <label>
                          <input type="checkbox" v-model="model.option_patients_choice">
                          <span>Выбор пациентов</span>
                        </label>
                      </td>
                    </tr>
                    <tr>
                        <td>
                            <label>Цена</label>
                            <ValidationProvider v-slot="{ errors }"
                                                :rules="{required: isTariffAbonement, numeric: true, max_value: 2147483647}">
                                <input v-mask="'##########'"
                                       type="number"
                                       v-model="model.price"
                                       v-units.literal="`руб`"
                                       :class="{'hasError' : errors[0]}"
                                       name="«Цена»"
                                       v-tooltip="{
                                           content: errors[0],
                                           template: $errTemplate,
                                       }">
                            </ValidationProvider>
                        </td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                    </tr>

                </table>
            </fieldset>

            <footer>
                <button class="green" @click="confirm">Подтвердить</button>
            </footer>
        </ValidationObserver>
    </v-dialog-old>
</template>

<script>

export default {
    data() {
        return {
            model: {
                option_map: false,
                option_callback: false,
                option_calltracking: false,
                option_patients_choice: true,
                id: '',
                tariff: '',
                duration: null,
                dateFrom: this.today,
                dateTill: '',
                price: '',
            },

            index: null,
            editMode: false,
            durationPreset: '',
            canEditDateFrom: true,
            canEditDateTill: true,
        }
    },

    methods: {
        new: function () {
            this.resetModel();
            this.canEditDateFrom = true;
            this.canEditDateTill = true;
        },

        edit: function (data, index) {
            this.model = JSON.parse(JSON.stringify(data));
            this.index = index;

            let dateFrom = this.$moment(this.model.dateFrom, "YYYY-MM-DD");
            let dateTill = this.model.dateTill ? this.$moment(this.model.dateTill, "YYYY-MM-DD") : null;
            let now = this.$moment();

            this.model.dateFrom = dateFrom.format('DD.MM.YYYY');
            if (dateTill) {
                this.model.dateTill = dateTill.format('DD.MM.YYYY');
            }

            this.canEditDateFrom = true;
            this.canEditDateTill = true;

            if (this.model.id !== '') {
                if (dateFrom <= now) {
                    this.canEditDateFrom = false;
                }

                if ((dateTill != null) && (dateTill <= this.$moment().subtract(1, 'days').startOf('day'))) {
                    this.canEditDateTill = false;
                }
            }

            this.editMode = true;

            this.showDialog();
        },

        showDialog: function () {
            this.$refs.dialog.show();
        },

        resetModel: function () {
            this.model = this.getCleanModel();
            this.index = null;
            this.canEditDateFrom = true;
            this.canEditDateTill = true;
        },

        createSubscription: function () {
            this.resetModel();
            this.showDialog();
            this.editMode = false;
        },

        confirm: function () {
            this.$refs.clinicSubscription.validate().then(success => {
                if (!success) {
                    const el = document.querySelector(".hasError:first-of-type");
                    el.scrollIntoView({behavior: "smooth"});
                    return;
                }

                let originalDateFrom = this.model.dateFrom;
                let originalDateTill = this.model.dateTill;

                this.model.dateFrom = (this.model.dateFrom ? this.formatDate(this.model.dateFrom) : null);
                this.model.dateTill = (this.model.dateTill ? this.formatDate(this.model.dateTill) : null);

                // maybe we need to clone the model
                const eventName = this.editMode ? "edit" : "confirm";

                this.$emit(eventName, JSON.parse(JSON.stringify(this.model)), this.index);

                if (this.model.isInvalid) {
                    this.model.isInvalid = false;
                    alert('Подписки не должны пересекаться в одном временном промежутке');
                } else if (!this.model.tariff) {
                    alert('Нужно выбрать тариф');
                } else {
                    this.closeDialog();
                }

                this.model.dateFrom = originalDateFrom;
                this.model.dateTill = originalDateTill;
            });
        },

        calculateDateTill: function () {
            let startDate = this.model.dateFrom ? this.model.dateFrom : this.today;

            if (this.model.duration) {
                this.model.dateTill = this.$moment(startDate, "DD.MM.YYYY")
                    .add(this.model.duration - 1, 'days')
                    .format("DD.MM.YYYY");
            } else {
                this.model.dateTill = '';
            }
        },

        calculateDuration: function () {
            if (this.model.dateFrom && this.model.dateTill) {
                let a = this.$moment(this.model.dateTill, "DD.MM.YYYY");
                let b = this.$moment(this.model.dateFrom, "DD.MM.YYYY");

                this.model.duration = a.diff(b, 'days') + 1;
            } else {
                if (this.model.dateTill === '') {
                    this.model.duration = null;
                }
            }
        },

        handleClearDateTill: function (newDateTill) {
            if (!newDateTill) {
                this.model.duration = null;
            }
        },

        setDurationPreset: function () {
            this.model.duration = this.durationPreset;
            this.calculateDateTill();

            this.$nextTick(function () {
                this.durationPreset = '';
            });
        },

        closeDialog: function () {
            this.$refs.dialog.hide();
        },

        formatDate: function (date) {
            let dateParts = date.split('.');

            return [dateParts[2], dateParts[1], dateParts[0]].join('-');
        },

        getCleanModel: function () {
            return {
                id: '',
                tariff: '',
                duration: 1,
                dateFrom: this.$moment().format("DD.MM.YYYY"),
                dateTill: this.$moment().format("DD.MM.YYYY"),
                price: '',
                option_map: false,
                option_callback: false,
                option_calltracking: false,
                option_patients_choice: true,
            };
        }
    },
    watch: {
      'model.price' (val)  {
          if (parseInt(val.substring(0,1)) === 0 && val.length>1) {
            this.model.price = val.substring(1)
          }
          if (val.indexOf('-') > -1){
              this.model.price = val.replace(/\-/g,'')
          }
      },
      'model.dateFrom' (val) {
          if (!val) {
              this.model.dateFrom = this.today;
          }
          if (this.model.duration) {
              this.calculateDateTill();
          }
      },
      'model.tariff': {
        handler(newTariff, oldValue) {
          if (newTariff !== 'ABONEMENT' && newTariff !== 'ABONEMENT_PLUS') {
            this.model.option_map = false
            this.model.option_callback = false
            this.model.option_calltracking = false
          }
          if ( newTariff !== 'ABONEMENT_PLUS') {
            this.model.option_patients_choice = false
          }
          if (oldValue) {
            this.model.option_patients_choice = newTariff === 'ABONEMENT_PLUS'
          }

        },
        immediate: false
      }
    },
    computed: {
        today: function () {
            return this.$moment().format("DD.MM.YYYY");
        },

        minDateTill: function () {
            let currentDate = this.$moment().startOf('day');
            let dateFrom = this.$moment(this.model.dateFrom, 'DD.MM.YYYY');

            return currentDate <= this.$moment(this.model.dateFrom, 'DD.MM.YYYY') ? dateFrom : this.$moment().subtract(1, 'days').startOf('day');
        },
        startOfToday: function () {
            return this.$moment().startOf('day');
        },
        isTariffAbonement: function () {
            return this.model.tariff === 'ABONEMENT' ||
                this.model.tariff === 'ABONEMENT_PLUS';
        },
    }
}
</script>

<style lang="scss">
    #vdialog {
        width: 600px;
    }

    #vueTableSettings {
        max-width: fit-content;
    }

    .clinicSubscription .mx-icon-calendar, .clinicSubscription .mx-icon-clear {
        top: calc(50% - 2px);
    }

    .clinicSubscription .mx-input {
        padding-bottom: 1px;
        color: black;
        font-size: 16px;
    }

    .mx-datepicker-popup {
        z-index: 10000;
    }

    .multiselect__option {
        min-height: 20px !important;
    }
    .subscribe-options {
        &__cell {

        }
    }
</style>
